// Meta podaci za dijeljenje objava (Open Graph, Twitter, JSON-LD).
// Crawleri društvenih mreža ne izvršavaju JavaScript — iste oznake za njih generira
// server/share-meta.js, pa promjene ovdje treba prenijeti i tamo.

const SITE = 'https://prdays.sum.ba'
const SITE_NAME = 'PR, Media & Sports Days University of Mostar'
const STORAGE = 'https://web-admin.sum.ba/api/storage/'
const DEFAULT_IMAGE = SITE + '/og-banner-2026.png'
const SECTIONS = {
    blog: {name: 'Blog', type: 'BlogPosting'},
    novosti: {name: 'Novosti', type: 'NewsArticle'},
}
const JSON_LD_ID = 'post-jsonld'

// Element -> {attr, value} (value === undefined znači da je element dodan pa se pri resetu briše)
const touched = new Map()
let originalTitle = null

function describe(post) {
    let text = post.subtitle || post.content_plain
    if (!text && post.content) {
        text = new DOMParser().parseFromString(post.content, 'text/html').body.textContent
    }
    text = (text || '').replace(/\s+/g, ' ').trim()
    return text.length > 160 ? text.slice(0, 157).replace(/\s+\S*$/, '') + '…' : text
}

export function buildPostMeta(post, section, alias, locale) {
    const info = SECTIONS[section]
    const url = SITE + '/' + section + '/' + encodeURI(alias)
    const image = post.images && post.images.length ? STORAGE + post.images[0] : DEFAULT_IMAGE
    const description = describe(post)
    const title = post.title + ' | ' + SITE_NAME
    const lang = locale === 'en' ? 'en' : 'hr'

    const tags = [
        ['name', 'description', description],
        ['property', 'og:type', 'article'],
        ['property', 'og:site_name', SITE_NAME],
        ['property', 'og:locale', lang === 'en' ? 'en_GB' : 'hr_HR'],
        ['property', 'og:url', url],
        ['property', 'og:title', post.title],
        ['property', 'og:description', description],
        ['property', 'og:image', image],
        ['property', 'og:image:secure_url', image],
        ['property', 'og:image:alt', post.title],
        // Dimenzije zadane slike (bannera) ne vrijede za slike objava
        ['property', 'og:image:width', null],
        ['property', 'og:image:height', null],
        ['property', 'article:published_time', post.raw_created_at],
        ['property', 'article:modified_time', post.raw_updated_at],
        ['property', 'article:section', info.name],
        ['name', 'twitter:card', 'summary_large_image'],
        ['name', 'twitter:title', post.title],
        ['name', 'twitter:description', description],
        ['name', 'twitter:image', image],
        ['name', 'twitter:image:alt', post.title],
    ]

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': info.type,
        headline: post.title.slice(0, 110),
        description,
        image: [image],
        datePublished: post.raw_created_at,
        dateModified: post.raw_updated_at || post.raw_created_at,
        inLanguage: lang,
        mainEntityOfPage: {'@type': 'WebPage', '@id': url},
        publisher: {'@type': 'Organization', name: SITE_NAME, url: SITE},
    }

    return {title, url, tags, jsonLd}
}

function remember(el, attr) {
    if (!touched.has(el)) touched.set(el, {attr, value: el.getAttribute(attr)})
}

function setTag(attr, key, value) {
    let el = document.head.querySelector('meta[' + attr + '="' + key + '"]')
    if (value === null || value === undefined || value === '') {
        if (el) {
            remember(el, 'content')
            el.parentNode.removeChild(el)
        }
        return
    }
    if (el) {
        remember(el, 'content')
    } else {
        el = document.createElement('meta')
        el.setAttribute(attr, key)
        touched.set(el, {attr: 'content', value: undefined})
        document.head.appendChild(el)
    }
    el.setAttribute('content', value)
}

function setCanonical(url) {
    let el = document.head.querySelector('link[rel="canonical"]')
    if (el) {
        remember(el, 'href')
    } else {
        el = document.createElement('link')
        el.setAttribute('rel', 'canonical')
        touched.set(el, {attr: 'href', value: undefined})
        document.head.appendChild(el)
    }
    el.setAttribute('href', url)
}

function setJsonLd(data) {
    let el = document.getElementById(JSON_LD_ID)
    if (!el) {
        el = document.createElement('script')
        el.type = 'application/ld+json'
        el.id = JSON_LD_ID
        document.head.appendChild(el)
    }
    el.textContent = JSON.stringify(data)
}

export function setPostMeta(post, section, alias, locale) {
    if (!post || !post.title) return
    const meta = buildPostMeta(post, section, alias, locale)
    if (originalTitle === null) originalTitle = document.title
    document.title = meta.title
    meta.tags.forEach(([attr, key, value]) => setTag(attr, key, value))
    setCanonical(meta.url)
    setJsonLd(meta.jsonLd)
}

export function resetPageMeta() {
    touched.forEach((original, el) => {
        if (original.value === undefined || original.value === null) {
            if (el.parentNode) el.parentNode.removeChild(el)
            return
        }
        el.setAttribute(original.attr, original.value)
        if (!el.parentNode) document.head.appendChild(el)
    })
    touched.clear()
    const jsonLd = document.getElementById(JSON_LD_ID)
    if (jsonLd) jsonLd.parentNode.removeChild(jsonLd)
    if (originalTitle !== null) document.title = originalTitle
    originalTitle = null
}
